<template>
  <div>
    <md-table>
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <h1 class="md-title">Cargos</h1>
        </div>
        <div class="md-toolbar-section-end">
          <md-field>
            <md-input
              v-model="search"
              placeholder="Buscar cargos"
              @input="searchOnTable"
            />
          </md-field>
          <md-button
            class="md-primary md-raised"
            @click.prevent="
              $router.push({
                name: 'CargoNovo',
                params: { localId: localId },
              })
            "
          >
            Cadastrar
          </md-button>
        </div>
      </md-table-toolbar>
      <md-table-row>
        <md-table-head>Cargos</md-table-head>
        <md-table-head>Pessoas</md-table-head>
        <md-table-head />
      </md-table-row>
      <md-table-row v-for="cargo in searched" :key="cargo.id" class="pt-2 pb-2">
        <md-table-cell>{{ cargo.titulo }}</md-table-cell>
        <md-table-cell>{{ cargo.quantidadeUsuarios }}</md-table-cell>
        <md-table-cell class="md-toolbar-section-end">
          <md-button
            class="md-raised md-primary"
            @click.prevent="
              $router.push({
                name: 'CargoEditar',
                params: { localId: localId, cargoId: cargo.id },
              })
            "
          >
            Editar
          </md-button>
          <md-button
            class="md-raised md-accent"
            @click="() => (excluirCargoId = cargo.id)"
          >
            Excluir
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>
    <md-dialog-confirm
      :md-active.sync="excluirCargoId"
      md-title="Deseja excluir esse cargo?"
      md-confirm-text="confirmar"
      md-cancel-text="cancelar"
      @md-cancel="() => (excluirCargoId = null)"
      @md-confirm="excluirCargo"
    />
  </div>
</template>

<script>
import http from '../../utils/http'

const toLower = (text) => {
  return text.toString().toLowerCase()
}

const searchByName = (items, term) => {
  if (term) {
    return items.filter((item) => toLower(item.titulo).includes(toLower(term)))
  }

  return items
}

export default {
  name: 'PessoaCargos',
  props: {
    localId: String,
  },
  data() {
    return {
      excluirCargoId: null,
      users: [],
      cargos: [],
      searched: [],
      search: null,
    }
  },
  async mounted() {
    await this.fetchCargos()
  },
  methods: {
    async fetchCargos() {
      this.cargos = (await http.get(`local/${this.localId}/cargo`)).cargos
      this.searched = this.cargos
    },
    searchOnTable() {
      this.searched = searchByName(this.cargos, this.search)
    },
    async excluirCargo() {
      await http.delete('cargo', this.excluirCargoId)
      await this.fetchCargos()
    },
  },
}
</script>
